import React, { useEffect, useMemo, useState } from "react";
import api from "@api";
import { NavLink, useParams } from "react-router-dom";
import "./DirectoryLeagueStanding.css";

function DirectoryLeagueStanding() {
 const { leagueNameAndId } = useParams();
 const directoryLeagueId = leagueNameAndId?.split("-").pop();

 const [league, setLeague] = useState(null);
 const [standings, setStandings] = useState(null);
 const [loading, setLoading] = useState(true);
 const [leagueFilter, setLeagueFilter] = useState("all");

 useEffect(() => {
  const fetchLeague = async () => {
   try {
    const res = await api.get(`/api/directory/leagues/${directoryLeagueId}`);
    setLeague(res.data);
   } catch (err) {
    console.error("Failed to fetch league standings page", err);
   }
  };

  const fetchStandings = async () => {
   try {
    const res = await api.get(
     `/api/directory/leagues/${directoryLeagueId}/standings`
    );
    setStandings(res.data);
   } catch (err) {
    console.error("Failed to fetch directory standings", err);
   } finally {
    setLoading(false);
   }
  };

  fetchLeague();
  fetchStandings();
 }, [directoryLeagueId]);

 const rows = standings?.standings || [];

 const leagueOptions = useMemo(() => {
  const leagueMap = new Map();

  rows.forEach((row) => {
   if (!row.seasonsLeagueId) return;

   leagueMap.set(String(row.seasonsLeagueId), row.leagueName || `League ${row.seasonsLeagueId}`);
  });

  return Array.from(leagueMap, ([id, name]) => ({
   id,
   name,
  }));
 }, [rows]);

 const filteredRows = rows.filter((row) => {
  if (leagueFilter === "all") return true;

  return String(row.seasonsLeagueId) === leagueFilter;
 });

 return (
  <div className="league-profile-page">
   <div className="league-profile-container">
    <div className="league-profile-public-tabs">
     <NavLink end to={`/leagues/${leagueNameAndId}`}>
      Overview
     </NavLink>

     <NavLink to={`/leagues/${leagueNameAndId}/schedule`}>
      Schedule
     </NavLink>

     <NavLink to={`/leagues/${leagueNameAndId}/standings`}>
      Standings
     </NavLink>
     <NavLink to={`/leagues/${leagueNameAndId}/players`}>
      Players
     </NavLink>
    </div>

    <div className="league-profile-card directory-standing-card">
     <div className="directory-standing-header">
      <div>
       <h1 className="directory-standing-title">
        {league?.name} Standings
       </h1>
      </div>

      {leagueOptions.length > 1 && (
       <div className="directory-standing-actions">
        <select
         value={leagueFilter}
         onChange={(e) => setLeagueFilter(e.target.value)}
         className="directory-standing-filter"
        >
         <option value="all">All Leagues</option>

         {leagueOptions.map((leagueOption) => (
          <option key={leagueOption.id} value={leagueOption.id}>
           {leagueOption.name}
          </option>
         ))}
        </select>
       </div>
      )}
     </div>

     {standings?.locked ? (
      <div className="directory-standing-empty">
       Standings are available with League Tools.
      </div>
     ) : filteredRows.length > 0 ? (
      <div className="directory-standing-table">
       <div className="directory-standing-table-header">
        <div>Rank</div>
        <div>Team</div>
        <div>W</div>
        <div>L</div>
        <div>Pct</div>
       </div>

       {filteredRows.map((row, index) => (
        <NavLink
         key={row.seasonsLeagueTeamId}
         to={`/leagues/${leagueNameAndId}/teams/${row.seasonsLeagueTeamId}`}
         className="directory-standing-row"
        >
         <div className="directory-standing-rank">{index + 1}</div>

         <div
          to={`/leagues/${leagueNameAndId}/teams/${row.seasonsLeagueTeamId}`}
          className="directory-standing-team-link"
         >
          {row.teamName}
         </div>

         <div>{row.wins}</div>
         <div>{row.losses}</div>
         <div>{row.winPct}</div>
        </NavLink>
       ))}
      </div>
     ) : (
      <div className="directory-standing-empty">
       Standings will appear once game results are added.
      </div>
     )}
    </div>
   </div>
  </div>
 );
}

export default DirectoryLeagueStanding;